<template>
  <div>
    <fieldset :disabled="loading">
      <div class="mb-3">
        <label for="exampleFormControlInput1" class="form-label"
          >Lütfen iptal gerekçenizi belirtiniz:</label
        >
        <textarea
          ref="description"
          v-model="description"
          class="form-control"
          required
          rows="5"
        ></textarea>
      </div>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-secondary"
              @click="$emit('back')"
            >
              Vazgeç
            </button>
            <button type="button" class="btn btn-danger" @click="cancel">
              İptal Et
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  data() {
    return {
      description: "",
      loading: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$refs.description.focus();
  },
  methods: {
    cancel() {
      if (!this.description) {
        this.$izonayAlert("Lütfen iptal gerekçenizi belirtiniz.").then(() => {  
          setTimeout(() => {
            this.$refs.description.focus();            
          }, 500);       
        })
        return;
      } else {
        this.loading = true;
        this.$emit("cancel", this.description);
      }
    }
  }
};
</script>
